export default "__VITE_ASSET__QXw8U6pG__"